import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "pl-8 d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_station_selection_page = _resolveComponent("station-selection-page")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_parameter_selection_page = _resolveComponent("parameter-selection-page")!
  const _component_station_download_page = _resolveComponent("station-download-page")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_stepper_navigation = _resolveComponent("stepper-navigation")!
  const _component_v_stepper = _resolveComponent("v-stepper")!

  return (_openBlock(), _createBlock(_component_v_stepper, {
    modelValue: _ctx.currentStep,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentStep) = $event)),
    class: "d-flex flex-column",
    elevation: "0",
    height: "100%",
    "data-testid": "station-download-stepper"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_stepper_header, { class: "height-56" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.datasetStore.metadata?.title), 1),
          _createVNode(_component_v_stepper_item, {
            complete: _ctx.currentStep > 1,
            "complete-icon": "mdi-check",
            color: "primary",
            value: 1
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('download_form.choose.station') +
            ` (${_ctx.stationStore.selectedStations.length})`), 1)
            ]),
            _: 1
          }, 8, ["complete"]),
          _createVNode(_component_v_stepper_item, {
            complete: _ctx.currentStep > 2,
            "complete-icon": "mdi-check",
            color: "primary",
            value: 2
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('download_form.choose.parameter') +
            ` (${_ctx.parameterStore.selectedParameters.length})`), 1)
            ]),
            _: 1
          }, 8, ["complete"]),
          _createVNode(_component_v_stepper_item, {
            value: 3,
            color: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('download_form.to_download')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_stepper_window, {
        modelValue: _ctx.currentStep,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentStep) = $event)),
        class: "fill-height ma-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_stepper_window_item, {
            class: "fill-height pa-4",
            value: 1
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_ctx.currentStep === 1)
                  ? (_openBlock(), _createBlock(_component_station_selection_page, {
                      key: 0,
                      ref: "stationPage"
                    }, null, 512))
                  : _createCommentVNode("", true)
              ], 1024))
            ]),
            _: 1
          }),
          _createVNode(_component_v_stepper_window_item, {
            class: "fill-height pa-4",
            value: 2
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_ctx.currentStep === 2)
                  ? (_openBlock(), _createBlock(_component_parameter_selection_page, {
                      key: 0,
                      ref: "parameterPage"
                    }, null, 512))
                  : _createCommentVNode("", true)
              ], 1024))
            ]),
            _: 1
          }),
          _createVNode(_component_v_stepper_window_item, {
            class: "fill-height pa-4",
            value: 3
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_ctx.currentStep === 3)
                  ? (_openBlock(), _createBlock(_component_station_download_page, {
                      key: 0,
                      ref: "downloadPage"
                    }, null, 512))
                  : _createCommentVNode("", true)
              ], 1024))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_stepper_navigation, {
        "hide-next": _ctx.hideNextButton,
        "hide-previous": _ctx.hidePreviousButton,
        "allow-next": _ctx.enableNextButton,
        onPrevious: _ctx.previousStep,
        onNext: _ctx.nextStep,
        onAbort: _ctx.abort
      }, null, 8, ["hide-next", "hide-previous", "allow-next", "onPrevious", "onNext", "onAbort"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}